// extracted by mini-css-extract-plugin
export default {"board_title":"SimplifyCard_board_title__9lW73","board_content":"SimplifyCard_board_content__oqmUQ","board_item":"SimplifyCard_board_item__Qge6b"};